<template>
  <div class="coupon-ticket" :class="[{checked: checked, disabled: disabled}, couponTypeClassName]"  @click="change(coupon)">
    <div class="coupon-badge" v-show="coupon.ifastExp"></div>
    <div class="coupon-header">
      <div class="title" :class="{disabled: disabled}"><span>— {{ coupon.couponType | couponType }} —</span></div>
    </div>
    <div class="coupon-body">
      <div class="coupon-m clearfix">
        <div class="price"><small>￥</small><span class="tag">{{ coupon.couponAmount }}</span></div>
        <div class="info">
          <div class="info-m">
            <div class="desc">满{{ coupon.couponQuata }}可用</div>
            <div class="date">有效期至{{ coupon.validEndDate | validate }}</div>
            <div class="status" :class="{'disabled': disabled}">
              <span v-if="checkedAble">{{ (coupon.couponStatus === 'UNUSED' && !disabled) ? '可使用' : '不可用' }}</span>
              <span v-else>
                <template v-if="coupon.couponStatus !== 'UNUSED'">
                  {{ coupon.couponStatus | couponStatus }}
                </template>
                <template v-else>
                  <a href="/">去使用</a>
                </template>
              </span>
            </div>
            <div class="more" @click.stop="showDetail">优惠券详情</div>
          </div>
          <div class="bord"><div class="brd"></div></div>
          <l8-icon v-show="checked" class="l8-icon checked-icon" type="icon-CombinedShape"/>
        </div>
      </div>
    </div>
    <a-modal
      title="优惠券详情"
      :visible="visible"
      destroyOnClose
      width="640px"
      @cancel="visible = false"
    >
      <template slot="footer">
        <a-button type="primary" @click="visible = false">
          确认
        </a-button>
      </template>
      <div class="mod-coupon-detail">
        <table>
          <colgroup>
            <col>
            <col>
            <col>
            <col>
            <col>
          </colgroup>
          <tbody>
            <tr>
              <td colspan="1">优惠券号</td>
              <td colspan="1">优惠券类型</td>
              <td colspan="1">使用平台</td>
              <td colspan="1">面额</td>
              <td colspan="1">使用限额</td>
              <td colspan="1">实名使用券</td>
            </tr>
            <tr>
              <td colspan="1">{{ coupon.couponNumber }}</td>
              <td colspan="1">{{ coupon.couponType | couponType }}</td>
              <td colspan="1">{{ coupon.usePlatform | usePlatform }}</td>
              <td colspan="1">{{ coupon.couponAmount }}元</td>
              <td colspan="1">{{ coupon.couponQuata }}元（含以上）</td>
              <td colspan="1">{{ coupon.couponUseType === 'REALNAME' ? '是' : '否' }}</td>
            </tr>
            <tr>
              <td colspan="3">适用航班日期</td>
              <td colspan="3">优惠券有效期</td>
            </tr>
            <tr>
              <td colspan="3">{{ coupon.applyFltDates | applyFltDates }}</td>
              <td colspan="3">{{ coupon.validity }}</td>
            </tr>
            <tr>
              <td colspan="3">适用航班</td>
              <td colspan="3">不适用航班</td>
            </tr>
            <tr>
              <td colspan="3">{{ coupon.flightNo || '-'  }}</td>
              <td colspan="3">{{ coupon.disabledFlightNo || '-' }}</td>
            </tr>
            <tr>
              <td colspan="3">适用产品</td>
              <td colspan="3">适用航线种类</td>
            </tr>
            <tr>
              <td colspan="3">{{ getAllowDetail(coupon.allowFltProudcts,"productName")  || '-' }}</td>
              <td colspan="3">{{ getAllowDetail(coupon.allowFltType,"flightName")  || '-' }}</td>
            </tr>
          </tbody>
        </table>
        <div class="tip">
          <h6>用券须知：</h6>
          <div v-html="returnTips()"></div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>

import moment from 'moment'
import '../../pages/usercoupon/config.js'
import getAppInfo from '@/utils/from'
const airlineName = getAppInfo()?.name || '本航司'
// const couponBgMaps = [
//   {
//     type: 'LUGGAGE',
//     image: require('./img/coupon-bg-luggage.png')
//   },
//   {
//     type: 'MEALS',
//     image: require('./img/coupon-bg-meal.png')
//   },
//   {
//     type: 'VIPHALL',
//     image: require('./img/coupon-bg-viphall.png')
//   },
//   {
//     type: 'TICKET',
//     image: require('./img/coupon-bg.png')
//   }
// ]
export default {
  name: 'CouponTicket',
  props: {
    data: Object,
    checked: Boolean,
    checkedAble: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      visible: false,
      couponCmsData: {},
      tipMap: {
        'TICKET':
            `<p>
              1.本券仅适用于${airlineName}国内航线，具体适用航线需符合用券条件，具体以上表为准。<br/>
              2.机票优惠券仅适用于单人单段航班订单。<br/>
              3.机票优惠券仅可用于抵扣机票款，不可抵扣其他费用。<br/>
              4.机票优惠券一经使用，进行退票、变更等操作时，均不予退还。<br/>
            </p>`,
        'LUGGAGE':
            `<p>
              1.本券仅适用于${airlineName}国内航线，具体适用航线需符合用券条件，具体以上表为准。<br/>
              2.每位乘客每个航段可使用一张行李优惠券。<br/>
              3.行李优惠券仅可用于抵扣逾重行李费，不可抵扣其他费用。<br/>
              4.行李优惠券一经使用，进行退票或退订行李等操作时，均不予退还。<br/>
            </p>`,
        'MEAL':
            `<p>
              1.本券仅适用于${airlineName}国内航线，具体适用航线需符合用券条件，具体以上表为准。<br/>
              2.每位乘客每个航段可使用一张餐食优惠券。<br/>
              3.餐食优惠券仅可用于抵扣机上餐食费，不可抵扣其他费用。<br/>
              4.餐食优惠券一经使用，进行退票或退订餐食等操作时，均不予退还。<br/>
            </p>`,
        'VIPHALL':
            `<p>
              1.本券仅适用于${airlineName}国内航线，具体适用航线需符合用券条件，具体以上表为准。<br/>
              2.每位乘客每个航段可使用一张贵宾厅优惠券。<br/>
              3.贵宾厅优惠券仅可用于抵扣贵宾厅费用，不可抵扣其他费用。<br/>
              4.贵宾厅优惠券一经使用，进行退票或退订贵宾厅等操作时，均不予退还。<br/>
            </p>`
      }

    }
  },
  computed: {
    coupon () {
      return this.data
    },
    disabled () {
      const { checkedAble, coupon } = this

      return checkedAble ? !coupon.iallowUse : coupon.couponStatus !== 'UNUSED'
    },
    getAllowDetail () {
      return function (value, type) {
        return value ? value.map(item => { return item[type] }).join(',') : ''
      }
    },
    couponTypeClassName () {
      return `coupon-type-${this.coupon.couponType}`
    },
    getContent () {
      const { tipMap, coupon } = this
      return tipMap[coupon.couponType]
    }
    // backgroundImage () {
    //   const image = couponBgMaps.find(item => item.type === this.coupon.couponType).image
    //   return `url(${image})`
    // }
  },
  created () {
    this.getCmsData()
  },
  methods: {
    showDetail () {
      this.visible = true
    },
    change (coupon) {
      if (this.disabled) {
        return
      }

      if (!this.checkedAble) {
        return
      }

      this.$emit('change', coupon)
    },
    async getCmsData () {
      try {
        await window.__MICRO_ROOT__?.cms?.getPageData().then(res => {
          this.couponCmsData = res || {}
        })
      } catch (err) {}
    },
    returnTips () {
      const { tipMap, coupon, couponCmsData } = this
      const { couponType } = coupon
      const couponData = couponCmsData[`usercoupon-${couponType.toLocaleLowerCase()}`]
      return couponData?.content || tipMap[couponType]
    }
  },
  filters: {
    validate: function (date) {
      return moment(date).format('YYYY-MM-DD')
    }
  }
}
</script>

<style lang="less">
  .coupon-ticket {
    width: 320px;
    height: 150px;
    background: url("./img/coupon-bg.png") no-repeat;
    background-size: cover;
    color: #fff;
    position: relative;
    transition: box-shadow 0.3s;

    &:hover {
      box-shadow: 0 0 5px 2px #ccc;
    }

    &.disabled {
      cursor: not-allowed;
      background: url("./img/coupon-bg.png") no-repeat;
      background-size: cover;
      background-position: -361px 0;
    }

    &.coupon-type-LUGGAGE {
      background-image: url("./img/coupon-bg-luggage.png");
      &.disabled {
        background-image: url("./img/coupon-bg-luggage.png");
      }
      .title {
        span {
          background-image: linear-gradient(to left, #2995ce, #5bc7df);
          background-clip: text;
          color: transparent;
          font-size: 15px;
        }
      }
      .status {
        background-image: linear-gradient(to left, #2995ce, #5bc7df);
      }

      .coupon-badge {
        background-image: url("./img/coupon-badge-luggage.png");
      }
    }

    &.coupon-type-MEALS {
      background-image: url("./img/coupon-bg-meal.png");
       &.disabled {
        background-image: url("./img/coupon-bg-meal.png");
      }

      .title {
        span {
          background-image: linear-gradient(to left, #f15108, #f57823);
          background-clip: text;
          color: transparent;
          font-size: 15px;
        }
      }

      .status {
        background-image: linear-gradient(to left, #f15108, #f57823);
      }

      .coupon-badge {
        background-image: url("./img/coupon-badge-meal.png");
      }
    }

    &.coupon-type-VIPHALL {
      background-image: url("./img/coupon-bg-viphall.png");
       &.disabled {
        background-image: url("./img/coupon-bg-viphall.png");
      }
      .title {
        span {
          background: #977257;
          background-clip: text;
          color: transparent;
          font-size: 12px;
        }
      }

      .status {
        background: #977257;
      }

      .coupon-badge {
        background-image: url("./img/coupon-badge-viphall.png");
      }
    }

    .more {
      cursor: pointer;
    }

    .coupon-badge {
      position: absolute;
      right: 0;
      top: 0;
      width: 80px;
      height: 58px;
      background: url("./img/coupon-badge.png") no-repeat;
      background-size: cover;
    }

    .coupon-header {
      height: 30px;

      .title {
        color: #fa2d36;
        display: block;
        margin: 0 auto;
        width: 85px;
        font-weight: bold;
        text-align: center;
        height: 23px;
        background: #fff;
        border-radius: 0 0 5px 5px;

        &.disabled {
          color: #666;
        }
      }
    }

    .coupon-body {
      padding: 2px 34px;
    }

    .coupon-m {
      width: 100%;
      box-sizing: border-box;
      clear: both;
      position: relative;

      .bord {
        content: '';
        padding: 3px;
        position: absolute;
        width: 100%;
        height: 100%;
        border: 2px solid #fff;
        border-radius: 5px;
        top: 0;
        left: 0;
        z-index: 1;

        .brd {
          width: 100%;
          height: 100%;
          border: 1px solid #fff;
          border-radius: 5px;
        }
      }

      .checked-icon {
        color: #4acd0b;
        position: absolute;
        font-size: 36px;
        right: -24px;
        bottom: -6px;
        z-index: 10;

        &:after {
          content: '';
          position: absolute;
          width: 66%;
          height: 66%;
          top: 17%;
          left: 17%;
          display: block;
          background: #fff;
          z-index: -1;
        }
      }
    }

    .info {
      width: 50%;
      padding: 12px 0;
      box-sizing: border-box;
      float: right;
      text-align: center;
      line-height: 1.4em;
    }

    .info-m {
      position: relative;
      z-index: 2;
    }

    .price {
      width: 50%;
      height: 106px;
      line-height: 106px;
      float: left;
      text-align: center;

      small {
        font-size: 16px;
        margin-right: -2px;
      }

      .tag {
        font-size: 61px;
        font-family: impact, sans-serif;
      }
    }

    .desc {
      font-size: 14px;
      font-weight: bold;
    }

    .date {
      font-size: 12px;
    }

    .status {
      margin: 2px auto;
      width: 78px;
      height: 22px;
      line-height: 22px;
      text-align: center;
      border-radius: 5px;
      background: linear-gradient(to right, #fa2d36, #da101a);

      &.disabled {
        background: #666;
      }
      a {
        color: #fff;
      }
    }

    .more {
      font-size: 12px;
      text-decoration: underline;
      cursor: pointer;
    }
  }

  .mod-coupon-detail {
    table {
      width: 100%;
      table-layout: fixed;
    }

    td {
      padding: 6px;
      border: 1px solid #ddd;
      font-size: 12px;
      vertical-align: middle;
    }

    tr:nth-child(2n+1) {
      td {
        background-color: #f5f5f5;
      }
    }

    .tip {
      margin-top: 12px;

      h6 {
        line-height: 28px;
        font-weight: 700;
      }

      p {
        line-height: 20px;
        font-size: 12px;
        color: #888;
      }
    }
  }
</style>
